import { render, staticRenderFns } from "./ScheduleView.vue?vue&type=template&id=3872665b&scoped=true"
import script from "./ScheduleView.vue?vue&type=script&lang=js"
export * from "./ScheduleView.vue?vue&type=script&lang=js"
import style0 from "./ScheduleView.vue?vue&type=style&index=0&id=3872665b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872665b",
  null
  
)

export default component.exports